<template>
    <div class="main_container">
        <div class="guide_text">옆으로 넘기며 게임 방법을 확인하세요.</div>
        <!-- <div style="text-align:center; font-size:70px; font-weight:700;">
            팩트체커 여러분 환영합니다!
        </div> -->
        <!-- <div style="text-align:center; font-size:30px; margin:10px 30px; font-weight:700;">
            인터넷에는 확인되지 않은 정보들이 떠돌고 있어요.<br>팩트 체크를 통해 진실과 거짓을 가려내세요!
        </div> -->

        <!-- <div style="text-align:center; margin-bottom:40px;">
            <img :src="require('../assets/img/tutorial.png')" width="600" alt="tutorial image" />
        </div> -->
        <!-- https://baianat.github.io/hooper/getting-started.html#installation -->

        <hooper class="hooper_main" @slide="slideEvent">

            <slide class="slide_container">
                <img src="../assets/img/tutorial_000.png" class="slide_image">
            </slide>

            <slide class="slide_container">
                <img src="../assets/img/tutorial_001.png" class="slide_image">
                <div class="tutorial_text">1. 이름을 입력해 팩트체커 등록을 합니다.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_002.png" class="slide_image">
                <div class="tutorial_text">2. 팩트체크하고 싶은 영역을 선택하세요.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_003.png" class="slide_image">
                <div class="tutorial_text">3. 각 영역의 사실인지 거짓인지 확인이 필요한 주제 중 판별하고 싶은 주제를 선택하세요.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_004.png" class="slide_image">
                <div class="tutorial_text">4. 다양한 미디어의 근거를 확인해 주제가 사실인지, 거짓인지 정보를 확보하세요.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_005.png" class="slide_image">
                <div class="tutorial_text">5. 근거에 담긴 정보들은 어떤 항목인지, 신뢰할 수 있는지 확인하세요.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_006.png" class="slide_image">
                <div class="tutorial_text">6. 근거의 정보를 모두 확인한 후 주제의 사실 여부를 판단할 근거로 채택할 것인지,<br>다른 근거를 살펴볼지 선택하세요.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_007.png" class="slide_image">
                <div class="tutorial_text">7. 채택한 근거를 바탕으로 주제의 사실 혹은 거짓을 판단해주세요.</div>
            </slide>
            <slide class="slide_container">
                <img src="../assets/img/tutorial_008.png" class="slide_image">
                <div class="tutorial_text">8. 팩트체크위원회와 의견이 일치하면 가짜 뉴스 검증에 성공합니다.<br>많은 주제를 검토해 가짜 뉴스를 검증해주세요.</div>
            </slide>

            <!-- <hooper-pagination slot="hooper-addons"></hooper-pagination> -->
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>

        <div class="bottom_btn_container" style="margin-top:10px;">
            <div :class="activeButton ? 'bottom_one_btn_active' : 'bottom_one_btn_inactive'"
                    @click="next">
                {{$t('btn_tutorial_view')}}
            </div>
        </div>
    </div>
</template>

<script>
import {
    Hooper,
    Slide,
    // Pagination as HooperPagination,
    Navigation as HooperNavigation
    } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
    name: 'TutorialView',

    components: {
        Hooper,
        Slide,
        // HooperPagination,
        HooperNavigation,
    },

    data() {
        return {
            activeButton: false
        }
    },

    methods: {
        next: function() {
            if(!this.activeButton) {
                return
            }
            let sound = document.getElementById("bgm")
            sound.pause()
            this.$router.push('/sectionList')
        },

        slideEvent: function(event) {
            // console.log(event)
            if(event.currentSlide == 8) {
                this.activeButton = true
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* pc */
@media screen and (min-width: 415px) {
    .bottom_one_btn_active {
        text-align: center;
        width: 400px;
        padding: 13px;
        border: 2px solid black;
        font-size:30px;
        color: black;
        cursor:pointer;
        font-weight: 700;
        background-color: white;
        box-shadow: 2px 2px 2px gray;
    }
    .bottom_one_btn_inactive {
        text-align: center;
        width: 400px;
        padding: 13px;
        font-size:30px;
        color: gray;
        font-weight: 700;
        background-color: lightgray;
    }
    .slide_image {
        width: 720px;
    }
    .hooper_main {
        width: 800px;
        height: 400px;
        margin-top: 0px;
        margin-left:auto;
        margin-right:auto;
    }
    .slide_container {
        text-align: center;
        font-size:20px;
    }
    .guide_text {
        text-align: center;
        font-size: 26px;
        font-weight: 700;
        margin: 20px;
        word-break: keep-all;
    }
    .tutorial_text {
        font-size: 16px;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .bottom_one_btn_active {
        text-align: center;
        width: 300px;
        padding: 13px;
        border: 2px solid black;
        font-size: 24px;
        color: black;
        cursor:pointer;
        font-weight: 700;
        background-color: white;
        box-shadow: 2px 2px 2px gray;
    }
    .bottom_one_btn_inactive {
        text-align: center;
        width: 300px;
        padding: 13px;
        font-size: 24px;
        color: gray;
        font-weight: 700;
        background-color: lightgray;
    }
    .slide_image {
        width: 350px;
    }
    .hooper_main {
        height: 300px;
        margin-top: 70px;
        margin-left:auto;
        margin-right:auto;
        margin-bottom: 70px;
        width:360px;
    }
    .slide_container {
        text-align: center;
        font-size: 16px;
    }
    .guide_text {
        text-align: center;
        font-size: 26px;
        font-weight: 700;
        margin: 20px;
        word-break: keep-all;
    }
    .tutorial_text {
        font-size: 16px;
        word-break: keep-all;
    }
}
</style>
